import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GradiLink from "./gradi-link"
import Socials from "./socials"
import Logo from "../assets/images/gradi-group.svg"
import { renderColor, renderHoverColor } from "../utils/gradi"

const CTABar = ({ currentBrand: { ctaBar = null } }) => {
  // const color = renderColor(currentBrand, data)
  // const hoverColors = renderHoverColor(currentBrand, data)

  if (!ctaBar?.enabled) {
    return <></>
  }

  const linkUrl = ctaBar?.linkUrl
  if (!linkUrl) {
    return <></>
  }
  const {
    linkUrl: { target, title, url },
  } = ctaBar
  return (
    <div className="text-base text-center bg-alternate w-full flex justify-center align-center font-extrabold uppercase p-2 ">
      <a
        className="text-center"
        href={url}
        dangerouslySetInnerHTML={{ __html: title }}
      ></a>
    </div>
  )
}

export default CTABar
